"use client";

import { Skeleton } from "@heroui/skeleton";
import { UserStatsSkeleton } from "./user-stats-skeleton";
import { QuestCardSkeleton } from "@/app/quests/_components/quest-card-skeleton";

export function QuestsPageSkeleton() {
  return (
    <div className="min-h-screen">
      {/* User Stats Skeleton */}
      <UserStatsSkeleton />

      {/* Quests Section */}
      <div className="w-full max-w-7xl mx-auto px-6 md:px-8 lg:px-12 py-12">
        {/* Task Group 1 */}
        <div className="mb-12">
          {/* Section Header */}
          <Skeleton className="rounded-lg w-64 h-9 mb-6" />

          {/* Quest Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 lg:gap-8">
            {Array.from({ length: 8 }).map((_, i) => (
              <QuestCardSkeleton key={i} />
            ))}
          </div>
        </div>

        {/* Task Group 2 */}
        <div className="mb-12">
          {/* Section Header */}
          <Skeleton className="rounded-lg w-56 h-9 mb-6" />

          {/* Quest Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 lg:gap-8">
            {Array.from({ length: 4 }).map((_, i) => (
              <QuestCardSkeleton key={i} />
            ))}
          </div>
        </div>

        {/* Task Group 3 */}
        <div className="mb-12">
          {/* Section Header */}
          <Skeleton className="rounded-lg w-48 h-9 mb-6" />

          {/* Quest Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 lg:gap-8">
            {Array.from({ length: 4 }).map((_, i) => (
              <QuestCardSkeleton key={i} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
